import { render, staticRenderFns } from "./Primary.vue?vue&type=template&id=1ce2dc91"
import script from "./Primary.vue?vue&type=script&lang=js"
export * from "./Primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports